import React, {ReactNode} from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {isLoggedIn} from '../utils';

interface ProtectedRouteProps {
    redirectPath?: string;
    children?: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
                                                           redirectPath = '/login',
                                                           children,
                                                       }) => {
    if (!isLoggedIn()) {
        return <Navigate to={redirectPath} replace/>;
    }

    return <>{children || <Outlet/>}</>;
};

export default ProtectedRoute;
